import { Activity } from 'components/timeline/RecentActivity';
import React from 'react';

const Step1 = () => {
  return (
    <>
      <Activity
        activity={{
          title: 'Crediti',
          text: (
            <span>
              Ogni squadra ha a disposizione <b>100 crediti</b> per acquistare i
              giocatori
            </span>
          ),
          icon: 'coins',
          status: 'completed'
        }}
      />
      <Activity
        activity={{
          title: 'Squadra',
          text: (
            <span>
              Ogni squadra deve acquistare <b>1 professore</b> caposquadra e
              <b> 4 alunni</b>
            </span>
          ),
          icon: 'users',
          status: 'completed'
        }}
      />
      <Activity
        activity={{
          title: 'Giocatori',
          text: (
            <span>
              Stessi <b>professori</b> o <b>alunni</b> possono essere{' '}
              <b>contemporaneamente in più squadre</b>
            </span>
          ),
          icon: 'people-arrows',
          status: 'completed'
        }}
      />
      <Activity
        activity={{
          title: 'Punteggi',
          text: (
            <span>
              I <b>punteggi</b> di ogni giocatore vengono inseriti dal{' '}
              <b>Capoclasse</b>
            </span>
          ),
          icon: 'chart-line',
          status: 'completed'
        }}
      />
    </>
  );
};

export default Step1;
